import {useQuery} from "@tanstack/react-query";
import {getUserWithdrawalLimit} from "../../services/wallet/getUserWithdrawalLimit";

const useGetUserWithdrawalLimit = () => {
  const {data, isError, isLoading, isSuccess, refetch, error} = useQuery({
    queryKey: ["userWithdrawalLimit"],
    queryFn: getUserWithdrawalLimit,
    staleTime: 1 * (60 * 1000), // 10 mins,
  });

  return {data: data?.data?.data, isError, isLoading, refetch, isSuccess, error};
};

export default useGetUserWithdrawalLimit;
